import React from "react";
import PropTypes from "prop-types";
import { getVarsoUrl } from "../../../../../common/helpers/helpers";

const Variant = ({ label, variantUrl, variant, variantOrigin }) => {
  return (
    <div className="varsome-horiz-list-item">
      <div className="varsome-horiz-list-label">{label}</div>
      <div className="varsome-horiz-list-value">
        <a target="_blank" href={getVarsoUrl(variantUrl)}>
          {variant}
        </a>
        {variantOrigin && (
          <span>
            <br />
            <small>{`(${variantOrigin})`}</small>
          </span>
        )}
      </div>
    </div>
  );
};

Variant.propTypes = {
  label: PropTypes.string,
  variantUrl: PropTypes.string,
  variant: PropTypes.string,
  variantOrigin: PropTypes.string,
};

Variant.defaultProps = {
  label: null,
  variantUrl: null,
  variant: null,
  variantOrigin: null,
};

export default Variant;
